
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AlertCircle, ChevronRight, ArrowLeft } from "lucide-react";
import PageTransition from "@/components/PageTransition";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Show toast notification
    toast.error(`Page not found: ${location.pathname}`, {
      description: "The page you're looking for doesn't exist or was moved."
    });
  }, [location.pathname]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <PageTransition className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <div className="text-center space-y-6">
          <div className="w-20 h-20 bg-expitrack-primary/10 rounded-full flex items-center justify-center mx-auto">
            <AlertCircle className="w-10 h-10 text-expitrack-primary" />
          </div>
          
          <h1 className="text-6xl font-bold text-expitrack-primary">404</h1>
          <h2 className="text-2xl font-bold text-expitrack-text">Page Not Found</h2>
          
          <p className="text-gray-600 max-w-sm mx-auto">
            We couldn't find the page you're looking for. It might have been moved or deleted.
            Current path: {location.pathname}
          </p>
          
          <div className="pt-6 flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="outline" 
              onClick={goBack}
              className="inline-flex items-center"
            >
              <ArrowLeft className="mr-1 w-4 h-4" /> Go Back
            </Button>
            <Link 
              to="/" 
              className="px-6 py-3 bg-expitrack-primary text-white rounded-md font-medium hover:bg-expitrack-primary/90 transition-all shadow-sm hover:shadow inline-flex items-center justify-center"
            >
              Return to Home <ChevronRight className="ml-1 w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default NotFound;
